/* eslint-disable */
import { TableFooter, TableRow, Table } from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import NavCommon from "../../components/@navHeader";
import { SearchBar } from "./components/SearchBar";
import { SharedLeadList } from "./components/SharedLeadList";
import axiosLead from "../../services/lead";
import warn from "../../constants/toast";
import { SharedLeadSkeleton } from "./components/SharedLeadSkeleton";
import { Context } from "../../context/Context";

import * as Styles from "./styles";
import { Lead } from "interfaces";
import PageDescription from "./components/PageDescription";

interface SharedWithProps {
  nomeCorretorDestino: string;
  dataCriacao: string;
  idCorretorDestinoSistemaOrigem?: string;
}

interface LeadProps {
  nomeLead: string;
  serialNumber: number;
  idLeadCorretorSistemaOrigem?: string;
  idLeadSistemaOrigem?: string;
  telefone: string;
  email: string;
  leadsCompartilhadosCom: Array<SharedWithProps>;
}

const SharedLead: React.FC = () => {
  const [leads, setLeads] = useState<any>([]);
  const [leadsTotal, setLeadsTotal] = useState<number>(0);
  const [pagesTotal, setPagesTotal] = useState<number>(0);
  const { filtersReports, setFiltersReports } = useContext(Context);
  // const [leadsParams, setLeadsParams] = useState<Params>({
  //   PalavrasChave: "",
  //   PaginaAtual: 1,
  //   TotalItensRetorno: 5,
  // });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    requestLeadsCompartilhados();
  }, [filtersReports]);

  const requestLeadsCompartilhados = async () => {
    setLoading(true);
    try {
      const response = await axiosLead.GetLeadsSharedTotal(filtersReports);
      setLeads(response?.data?.data);
      setLeadsTotal(response?.data?.pagination?.totalItems);
      setPagesTotal(response?.data?.pagination?.quantityPages);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      warn.wargingError(
        `${
          error?.response?.data?.notifications?.map(
            (item: any) => `${item.message}\n`
          ) || "Error!"
        }`
      );
    }
  };

  const handlePagination = (_e: any, _page: number) => {
    setFiltersReports({
      PalavrasChave: filtersReports.PalavrasChave,
      PaginaAtual: _page,
      TotalItensRetorno: 5,
    });
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFiltersReports({
      ...filtersReports,
      TotalItensRetorno: parseInt(event.target.value, 10),
    });
  };

  const handleChangePage = (page: number) => {
    setFiltersReports({ ...filtersReports, PaginaAtual: page });
  };

  const history = useHistory();
  return (
    <Styles.Container>
      <NavCommon
        breadcrumbs={[
          { path: "/leads", name: "Carteira" },
          { path: "", name: "Leads Compartilhados" },
        ]}
        showButtonNew={false}
        onBack={() => {
          history.goBack();
        }}
        onChangeActionNew={() => {}}
      />
      <PageDescription
        title="Meus leads compartilhados"
        description="Aqui você pode ver todos os seus leads compartilhados com outro corretor, além de poder desfazer esse compartilhamento"
      />
      <Styles.Content>
        <Table>
          <SearchBar
            valueFromContext={filtersReports.PalavrasChave}
            setFilters={setFiltersReports}
            filters={filtersReports}
          />
          {loading ? (
            <SharedLeadSkeleton />
          ) : (
            <SharedLeadList
              leadsTotal={leadsTotal}
              data={leads}
              refreshLeads={() => requestLeadsCompartilhados()}
            />
          )}
          {!loading && (
            <TableFooter>
              <TableRow>
                <Styles.ContainerPagination>
                  <Styles.Arrows>
                    <Pagination
                      color="standard"
                      count={pagesTotal}
                      page={filtersReports.PaginaAtual}
                      onChange={handlePagination}
                      showFirstButton
                      size="small"
                      variant="outlined"
                      shape="round"
                      showLastButton
                    />
                  </Styles.Arrows>
                  <Styles.Arrows>
                    <small style={{ fontFamily: "Inter" }}>
                      Itens por página
                    </small>
                    <Styles.Select
                      displayEmpty
                      inputProps={{ "aria-label": "Without label" }}
                      color="secondary"
                      variant="outlined"
                      labelId="pages"
                      id="pages"
                      value={filtersReports?.TotalItensRetorno || 10}
                      label="Pages"
                      onChange={(event: any) => {
                        setFiltersReports({
                          PalavrasChave: filtersReports.PalavrasChave,
                          PaginaAtual: filtersReports.PaginaAtual,
                          TotalItensRetorno: event.target.value,
                        });
                      }}
                    >
                      <Styles.MenuItem value={5}>5</Styles.MenuItem>
                      <Styles.MenuItem value={10}>10</Styles.MenuItem>
                      <Styles.MenuItem value={15}>15</Styles.MenuItem>
                      <Styles.MenuItem value={20}>20</Styles.MenuItem>
                    </Styles.Select>
                  </Styles.Arrows>
                </Styles.ContainerPagination>
              </TableRow>
            </TableFooter>
          )}
        </Table>
      </Styles.Content>
    </Styles.Container>
  );
};

export default SharedLead;
